<div [ngClass]="position" class="dropdown-menu" [class.visible]="isVisible">
  <ng-content></ng-content>
</div>